import { PageComponents } from '@my-types';
import { React, Styled } from '@common/3rd';
import { Page } from '@component';
import DeskPageBody from './desk-page-body';
import DeskPageHeader from './desk-page-header';
import DeskPageFooter from './desk-page-footer';

/**
 * 桌面页面
 */
class DeskPage<P, S, C extends PageComponents> extends Page<P, S, C> {
	protected initComponents(): C {
		const C = super.initComponents();
		return Object.assign(C, {
			Box: Styled(C.Box).attrs({
				'data-widget': 'desk-page'
			})``
		}) as C;
	}
	protected getHtmlTitle(): string | null {
		return null;
	}
	renderPageHeader() {
		return <DeskPageHeader />;
	}
	renderPageBody() {
		return <DeskPageBody />;
	}
	renderPageFooter() {
		return <DeskPageFooter />;
	}
}

export default DeskPage;
